<template>
  <div>
    <!-- pc -->
    <div class="qualityContainer_pc">
      <div class="topPart">
        <div class="left">
          从原料到成品<br />
          都经过<br />
          严格的检测
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/top_right_pic_pc.png"
          class="top_right_pic top_right_pic_1920"
        />
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/top_right_pic_pc_1440.png"
          class="top_right_pic top_right_pic_1440"
        />
      </div>

      <div class="gridBox">
        <div class="item">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon1.png"
            class="icon"
          />
          <div class="label1">甄选原料</div>
          <div class="label2">一切从更好的原料开始</div>
        </div>
        <div class="item">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon2.png"
            class="icon"
          />
          <div class="label1">优质配方</div>
          <div class="label2">100%透明的成分和剂量</div>
        </div>
        <div class="item">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon4.png"
            class="icon"
          />
          <div class="label1">严苛测试</div>
          <div class="label2">安全和功效的四重保障</div>
        </div>
        <div class="item">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon3.png"
            class="icon"
          />
          <div class="label1">全链认证</div>
          <div class="label2">更高标准 服用安心</div>
        </div>
        <div class="item br">
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon5.png"
            class="icon"
          />
          <div class="label1">透明溯源</div>
          <div class="label2">全球溯源 品质见证</div>
        </div>
      </div>

      <div class="partThree">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/pic1_pc.png"
          class="p3_img"
        />
        <div class="right">
          <div class="mainTitle">Product Quality</div>
          <div class="subTitle">黄金级标准 专业级品质</div>
          <div class="des">
            我们的补剂拥有16项产品专利技术，确保营养补充不仅安全而且更加高效。橘袋对卓越品质的不<br />懈追求，体现在每一个细节之中，优中选优，致力于为您提供最佳的产品体验。
          </div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/brand_pc.png"
            class="p3_brand_img"
          />
        </div>
      </div>

      <div class="partFour">
        <div class="left">
          <div class="title1">Authoritive Certification</div>
          <div class="title2">橘袋资质 权威认证</div>
          <div class="certificationRow">
            <div class="left">
              <div class="name">FDA注册证书</div>
              <div class="des_zs">
                橘袋公司在美国食药监管局注册备案， 受FDA监管。
              </div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c1_pc.png"
                class="zhengshu"
                style="
                  margin-right: -0.2415rem;
                  width: 1.63rem;
                  height: 2.02rem;
                "
              />
            </div>
          </div>
          <div class="certificationRow">
            <div class="left">
              <div class="name">NSF认证证书</div>
              <div class="des_zs">
                连续三年获得补剂届“米其林三星” NSF GMP认证。
              </div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c2_pc.png"
                class="zhengshu"
                style="width: 1.69rem; height: 1.91rem"
              />
            </div>
          </div>
          <div class="certificationRow">
            <div class="left">
              <div class="name">ISO9001/ISO2000证书</div>
              <div class="des_zs">获国际质量管理体系权威认证。</div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c3_pc.png"
                class="zhengshu"
                style="
                  margin-right: -0.1208rem;
                  width: 1.52rem;
                  height: 1.89rem;
                "
              />
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c4_pc.png"
                class="zhengshu"
                style="margin-right: -0.1208rem"
              />
            </div>
          </div>
        </div>
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/factory_pc.png"
          class="p4_img"
        />
      </div>

      <div class="partFive">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/last_pic_pc.png"
          class="p5_img"
        />

        <div class="right">
          <div class="txt">Starting a Healthy Life</div>
          <div class="makeBtn cursor" @click="toMake($event, 0)">
            Try NUTRIPACKS Now
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/arr_r_w.png"
              class="arrR"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="qualityContainer_m">
      <div class="redBgPart redBgPart_414">
        从原料到成品<br />
        都经过<br />
        严格的检测
      </div>
      <div class="redBgPart redBgPart_768">
        从原料到成品<br />
        都经过严格的检测
      </div>
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/quality/top_right_pic_414.png"
        class="topImg topImg_414"
      />
      <img
        src="https://cdn-file.xiaojudai.cn/web/dist/quality/top_right_pic_768.png"
        class="topImg topImg_768"
      />

      <div class="cardPart cardPart_414">
        <div class="line">
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon1.png"
              class="icon"
            />
            <div class="label1">甄选原料</div>
            <div class="label2">一切从更好的原料开始</div>
          </div>
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon2.png"
              class="icon"
            />
            <div class="label1">优质配方</div>
            <div class="label2">100%透明的成分和剂量</div>
          </div>
        </div>
        <div class="dash_line"></div>
        <div class="line">
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon3.png"
              class="icon"
            />
            <div class="label1">全链认证</div>
            <div class="label2">更高标准 服用安心</div>
          </div>
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon4.png"
              class="icon"
            />
            <div class="label1">严苛测试</div>
            <div class="label2">安全和功效的四重保障</div>
          </div>
        </div>
        <div class="dash_line"></div>
        <div class="line">
          <div class="item br">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon5.png"
              class="icon"
            />
            <div class="label1">透明溯源</div>
            <div class="label2">全球溯源 品质见证</div>
          </div>
        </div>
      </div>

      <div class="cardPart cardPart_768">
        <div class="line">
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon1.png"
              class="icon"
            />
            <div class="label1">甄选原料</div>
            <div class="label2">一切从更好的原料开始</div>
          </div>
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon2.png"
              class="icon"
            />
            <div class="label1">优质配方</div>
            <div class="label2">100%透明的成分和剂量</div>
          </div>
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon4.png"
              class="icon"
            />
            <div class="label1">严苛测试</div>
            <div class="label2">安全和功效的四重保障</div>
          </div>
        </div>
        <div class="line" style="margin-top: 0.74rem">
          <div class="item">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon3.png"
              class="icon"
            />
            <div class="label1">全链认证</div>
            <div class="label2">更高标准 服用安心</div>
          </div>
          <div class="item br">
            <img
              src="https://cdn-file.xiaojudai.cn/web/dist/quality/icon5.png"
              class="icon"
            />
            <div class="label1">透明溯源</div>
            <div class="label2">全球溯源 品质见证</div>
          </div>
        </div>
      </div>
      <div class="whitePart">
        <div class="qualityPart">
          <div class="mainTitle">Product Quality</div>
          <div class="subTitle">黄金级标准 专业级品质</div>
          <div class="des">
            我们的补剂拥有16项产品专利技术，确保营养补充不仅安全而且更加高效。橘袋对卓越品质的不懈追求，体现在每一个细节之中，优中选优，致力于为您提供最佳的产品体验。
          </div>
          <img src="https://cdn-file.xiaojudai.cn/web/dist/quality/pic1.png" />
        </div>

        <img
          class="brandWall"
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/brand_pc.png"
        />
      </div>
      <div class="pinkPart">
        <div class="qualityPart">
          <div class="mainTitle">Authoritive Certifacation</div>
          <div class="subTitle">橘袋资质 权威认证</div>
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/factory_414.png"
            class="img2 img2_414"
          />
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/factory_768.png"
            class="img2 img2_768"
          />
          <div class="certificationRow">
            <div class="left">
              <div class="name">FDA注册证书</div>
              <div class="des_zs des_zs_414">
                橘袋公司在美国食药监管局注册备案，<br />
                受FDA监管。
              </div>
              <div class="des_zs des_zs_768">
                橘袋公司在美国食药监管局注册备案， 受FDA监管。
              </div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c1.png"
                class="zhengshu"
                style="margin-right: -0.2415rem"
              />
            </div>
          </div>
          <div class="certificationRow">
            <div class="left">
              <div class="name">NSF认证证书</div>
              <div class="des_zs des_zs_414">
                连续三年获得补剂届“米其林三星” <br />NSF GMP认证。
              </div>
              <div class="des_zs des_zs_768">
                连续三年获得补剂届“米其林三星”NSF GMP认证。
              </div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c2.png"
                class="zhengshu"
              />
            </div>
          </div>
          <div class="certificationRow">
            <div class="left">
              <div class="name">ISO9001/ISO2000证书</div>
              <div class="des_zs">获国际质量管理体系权威认证。</div>
            </div>
            <div class="right">
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c3.png"
                class="zhengshu"
              />
              <img
                src="https://cdn-file.xiaojudai.cn/web/dist/quality/c4.png"
                class="zhengshu"
                style="margin-right: -0.1208rem"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="lastPart">
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/last_pic_414.png"
          class="girlPic girlPic_414"
        />
        <img
          src="https://cdn-file.xiaojudai.cn/web/dist/quality/last_pic_768.png"
          class="girlPic girlPic_768"
        />
        <div class="startingTxt">Starting a Healthy Life</div>
        <div class="makeBtn cursor" @click="toMake($event, 0)">
          Try NUTRIPACKS Now
          <img
            src="https://cdn-file.xiaojudai.cn/web/dist/quality/arr_r_w.png"
            class="arrR"
          />
        </div>
      </div>
    </div>
    <!-- 定制弹窗 -->
    <CodePupop
      ref="myPupop"
      :position="position"
      :left="left"
      :top="top"
    ></CodePupop>
  </div>
</template>
  <script>
if (navigator.userAgent.indexOf("AliApp") > -1) {
  document.writeln(
    '<script src="https://appx/web-view.min.js"' + ">" + "<" + "/" + "script>"
  );
}
</script>
  <script>
// my.onMessage = function(e) {
//     console.log(e); // {'sendToWebView': '1'}
// 		alert('123')
//   }
</script>
  <script>
import Swiper from "swiper";
import CodePupop from "../components/codePupop.vue";

import { md5 } from "../util/md5.js";
export default {
  name: "index",
  components: { CodePupop },
  data: () => ({
    page: "home",
    items: [
      {
        id: 1,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
      {
        id: 2,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
      {
        id: 3,
        image:
          "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      },
    ],
    list: [
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/common/images/official-website/storeimgs/about/about2.jpg",
    ],
    position: "bottom",
    left: 0,
    top: 0,
  }),
  mounted() {
    new Swiper(".swiper-container", {
      slidesPerView: 4, // 每个视图显示 1.5 个滑块
      spaceBetween: 10, // 滑块之间的间隙
      centeredSlides: true, // 活动块居中
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".custom-button-next",
        prevEl: ".custom-button-prev",
      },

      //   effect: "coverflow", // 使用 coverflow 效果
      // grabCursor: true,
      //   coverflowEffect: {
      //     rotate: 0, // 滑块的旋转角度
      //     stretch: 0, // 滑块的拉伸值
      //     depth: 100, // 滑块的深度
      //     modifier: 1, // 缩放比例
      //     slideShadows: false, // 是否显示阴影
      //   },
    });
  },
  created() {},
  methods: {
    toMake(event, type) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;

      this.$refs.myPupop.showPupop(type);
    },
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
  },
};
</script>
  
<style scoped lang="scss">
.cursor {
  cursor: pointer;
}
//mobile414
@media screen and (max-width: 767px) {
  .qualityContainer_pc {
    display: none;
  }
  .qualityContainer_m {
    margin-top: 1.38rem;
    position: relative;
    overflow-x: hidden;

    .redBgPart {
      background: #c25e4d;
      height: 4.69rem;
      display: flex;
      justify-content: center;
      align-items: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 0.72rem;
      color: #ffffff;
      line-height: 1.01rem;
      text-align: center;
      font-style: normal;
    }
    .redBgPart_768 {
      display: none;
    }
    .topImg {
      height: 7.22rem;
      width: 100%;
    }
    .topImg_768 {
      display: none;
    }
    .cardPart {
      width: calc(100% - 1.16rem);
      height: 9.2rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 10.34rem;
      background: linear-gradient(
        141deg,
        #cecece 0%,
        #ffffff 52%,
        #dadada 100%,
        #e6e6e6 100%
      );
      box-shadow: 0rem 0.05rem 0.1rem 0rem rgba(0, 0, 0, 0.08);
      border-radius: 0.19rem;
      display: flex;
      flex-wrap: wrap;
      padding: 0.85rem 0.7rem;
      .line {
        width: 100%;
        display: flex;
        .item {
          width: 50%;
          height: 1.93rem;
          border-right: 2px dashed rgba(0, 0, 0, 0.22);
          .icon {
            width: 0.92rem;
            height: 0.92rem;
          }
          .label1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.34rem;
            color: #141414;
            line-height: 0.68rem;
            text-align: center;
            font-style: normal;
          }
          .label2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.29rem;
            color: #141414;
            line-height: 0.39rem;
            text-align: center;
            font-style: normal;
          }
        }
        .br {
          border-right: 2px dashed rgba(0, 0, 0, 0.22) !important;
        }
        .item:last-child {
          border-right: 0;
        }
      }
      .dash_line {
        border-bottom: 2px dashed rgba(0, 0, 0, 0.22);
        width: 100%;
        height: 1px;
        margin: 14px 0;
      }
    }
    .cardPart_768 {
      display: none;
    }

    .whitePart,
    .pinkPart {
      padding: 0 0.58rem;
      padding-top: 9.57rem;
      padding-bottom: 1.93rem;
      background-color: #fff;
      .qualityPart {
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.72rem;
          color: #141414;
          line-height: 0.85rem;
          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.31rem;
          color: #000000;
          line-height: 0.43rem;
          text-align: center;
          font-style: normal;
          margin-top: 0.24rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.29rem;
          color: #141414;
          line-height: 0.58rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.97rem;
        }
        img {
          // height: 6.96rem;
          width: 100%;
          margin-top: 0.97rem;
        }
      }
      .brandWall {
        width: 100%;
        // height: 8.84rem;
        height: auto;

        margin-top: 1.45rem;
      }
    }

    .pinkPart {
      padding-top: 0;
      margin-top: 0rem;
      background-color: #f6f4f1;
      padding-top: 1.45rem;
      padding-bottom: 0.94rem;
      .qualityPart {
        .img2 {
          // height: 8.84rem;
          height: auto;
          margin-bottom: 0.94rem;
        }
        .img2_768 {
          display: none;
        }
      }
      .certificationRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 2.72rem;
        border-bottom: 0.01rem solid #1a1a1a;
        .left {
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.34rem;
            color: #1a1a1a;
            line-height: 0.34rem;
            text-align: left;
            font-style: normal;
          }
          .des_zs {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.29rem;
            color: #1a1a1a;
            line-height: 0.48rem;
            text-align: left;
            font-style: normal;
            margin-top: 0.29rem;
          }
          .des_zs_768 {
            display: none;
          }
        }
        .right {
          .zhengshu {
            width: 1.84rem;
            height: 2.25rem;
            margin-top: 0;
          }
        }
      }
      .certificationRow:last-child {
        border-bottom: none;
      }
    }
    .lastPart {
      background-color: white;
      padding: 1.93rem 0.58rem 1.93rem 0.58rem;
      .girlPic {
        width: 100%;
        // height: 8.84rem;
        height: auto;
      }
      .girlPic_768 {
        display: none;
      }
      .startingTxt {
        font-family: MADEEvolveSans, MADEEvolveSans;
        font-weight: bold;
        font-size: 0.72rem;
        color: #141414;
        line-height: 1.45rem;
        text-align: center;
        font-style: normal;
        margin-top: 0.87rem;
      }
      .makeBtn {
        width: 5.89rem;
        height: 1.06rem;
        background: #c25e4d;
        border-radius: 0.97rem;
        margin: 0 auto;
        margin-top: 0.31rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;

        font-weight: 500;
        font-size: 0.31rem;
        color: #ffffff;
        line-height: 0.43rem;
        text-align: left;
        font-style: normal;
        .arrR {
          margin-left: 0.22rem;
          width: 0.41rem;
          height: 0.34rem;
        }
      }
    }
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .qualityContainer_pc {
    display: none;
  }
  .qualityContainer_m {
    margin-top: 1.64rem;
    position: relative;
    overflow-x: hidden;

    .redBgPart {
      background: #c25e4d;
      height: 5.24rem;
      display: flex;
      justify-content: center;
      align-items: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 0.81rem;
      color: #ffffff;
      line-height: 1.15rem;

      text-align: center;
      font-style: normal;
    }
    .redBgPart_414 {
      display: none;
    }
    .topImg {
      height: 10.28rem;
      width: 100%;
    }
    .topImg_414 {
      display: none;
    }
    .cardPart {
      width: calc(100% - 1.62rem);
      height: 7.06rem;

      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      top: 12.54rem;
      background: linear-gradient(
        141deg,
        #cecece 0%,
        #ffffff 52%,
        #dadada 100%,
        #e6e6e6 100%
      );
      box-shadow: 0rem 0.04rem 0.07rem 0rem rgba(0, 0, 0, 0.08);
      border-radius: 0.15rem;

      display: flex;
      flex-wrap: wrap;

      padding: 0.85rem 1.04rem;
      padding-top: 0.7rem;
      padding-bottom: 0.87rem;
    }
    .cardPart_414 {
      display: none;
    }
    .cardPart_768 {
      .line {
        width: 100%;
        display: flex;
        .item {
          width: 50%;
          height: 2.34rem;
          border-right: none;
          .icon {
            width: 1.15rem;
            height: 1.15rem;
          }
          .label1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 0.33rem;
            color: #141414;
            line-height: 0.52rem;

            text-align: center;
            font-style: normal;
            margin-top: 0.2rem;
          }
          .label2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #141414;
            line-height: 0.3rem;

            text-align: center;
            font-style: normal;
            margin-top: 0.2rem;
          }
        }
        .br {
          border-right: none !important;
        }
        .item:last-child {
          border-right: 0;
        }
      }
    }

    .whitePart,
    .pinkPart {
      padding: 0 0.81rem;
      padding-top: 5.89rem;
      padding-bottom: 1.85rem;
      background-color: #fff;
      .qualityPart {
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;

          text-align: center;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #333333;
          line-height: 0.56rem;

          text-align: center;
          font-style: normal;
          margin-top: 0.15rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.52rem;

          text-align: center;
          font-style: normal;
          margin-top: 0.46rem;
        }
        img {
          // height: 6.96rem;
          width: 100%;
          margin-top: 1.11rem;
        }
      }
      .brandWall {
        width: 100%;
        // height: 8.84rem;
        height: auto;

        margin-top: 1.06rem;
      }
    }

    .pinkPart {
      margin-top: 0rem;
      background-color: #f6f4f1;

      padding-top: 1.48rem;
      padding-bottom: 1.85rem;
      .qualityPart {
        .img2 {
          // height: 8.84rem;
          height: auto;

          margin-bottom: 0.76rem;
        }
        .img2_414 {
          display: none;
        }
      }
      .certificationRow {
        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 2.52rem;

        border-bottom: 0.01rem solid #1a1a1a;
        .left {
          .name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.3rem;
            color: #1a1a1a;
            line-height: 0.26rem;

            text-align: left;
            font-style: normal;
          }
          .des_zs {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 0.26rem;
            color: #1a1a1a;
            line-height: 0.37rem;

            text-align: left;
            font-style: normal;

            margin-top: 0.33rem;
          }
          .des_zs_414 {
            display: none;
          }
        }
        .right {
          .zhengshu {
            width: 1.64rem;
            height: 2.02rem;

            margin-top: 0;
          }
        }
      }
      .certificationRow:last-child {
        border-bottom: none;
      }
    }
    .lastPart {
      background-color: white;
      padding: 1.93rem 0.58rem 1.93rem 0.58rem;
      .girlPic {
        width: 100%;
        // height: 8.84rem;
        height: auto;
      }
      .girlPic_414 {
        display: none;
      }
      .startingTxt {
        font-family: MADEEvolveSans, MADEEvolveSans;
        font-weight: bold;
        font-size: 0.81rem;
        color: #141414;
        line-height: 1.11rem;

        text-align: center;
        font-style: normal;
        margin-top: 1.48rem;
      }
      .makeBtn {
        width: 4.74rem;
        height: 1.3rem;

        background: #c25e4d;

        border-radius: 0.74rem;
        margin: 0 auto;

        margin-top: 1.11rem;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 0.3rem;
        color: #ffffff;
        line-height: 0.41rem;

        text-align: left;
        font-style: normal;
        .arrR {
          margin-left: 0.2rem;
          width: 0.3rem;
          height: 0.2rem;
        }
      }
    }
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .qualityContainer_m {
    display: none;
  }
  .qualityContainer_pc {
    position: relative;
    .topPart {
      height: 9.93rem;
      display: flex;
      .left {
        height: 100%;
        width: 35%;
        background: #c25e4d;

        display: flex;
        justify-content: center;
        align-items: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.81rem;
        color: #ffffff;
        line-height: 1.33rem;

        text-align: left;
        font-style: normal;
      }
      .top_right_pic {
        height: 100%;
        width: 65%;
      }
      .top_right_pic_1920 {
        display: none;
      }
    }
    .gridBox {
      width: 22.46rem;
      height: 4.37rem;
      background: linear-gradient(
        141deg,
        #cecece 0%,
        #ffffff 52%,
        #dadada 100%,
        #e6e6e6 100%
      );
      box-shadow: 0rem 0.04rem 0.07rem 0rem rgba(0, 0, 0, 0.08);
      border-radius: 0.15rem;

      position: absolute;
      left: 50%;
      z-index: 1;
      transform: translateX(-50%);

      top: 8.76rem;

      display: flex;
      padding: 1rem 0;

      .item {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px dashed rgba(0, 0, 0, 0.22);
        .icon {
          width: 1.15rem;
          height: 1.15rem;
        }
        .label1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.33rem;
          color: #141414;
          line-height: 0.52rem;

          text-align: right;
          font-style: normal;

          margin-top: 0.39rem;
        }
        .label2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.3rem;
          text-align: right;
          font-style: normal;
          margin-top: 0.19rem;
        }
      }
    }
    .partThree {
      background-color: #f0f2f5;
      // background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      padding-top: 5.8rem;
      padding-bottom: 2.59rem;
      .p3_img {
        width: 10.04rem;
        height: 8.78rem;
        margin-right: 1.94rem;
      }
      .right {
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;

          text-align: left;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #333333;
          line-height: 0.56rem;

          text-align: left;
          font-style: normal;
          margin-top: 0.15rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.52rem;

          text-align: left;
          font-style: normal;
          margin-top: 0.46rem;
        }
        .p3_brand_img {
          width: 10.89rem;
          height: 2.63rem;
          margin-top: 1.11rem;
        }
      }
    }
    .partFour {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 15.19rem;
      background: #f6f4f1;
      .left {
        margin-right: 2.0rem;
        .title1 {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;

          text-align: left;
          font-style: normal;
        }
        .title2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #1a1a1a;
          line-height: 0.56rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.15rem;
          margin-bottom: 1.48rem;
        }

        .certificationRow {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 2.52rem;
          border-bottom: 0.01rem solid #1a1a1a;
          width: 9.8rem;
          .left {
            .name {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3rem;
              color: #1a1a1a;
              line-height: 0.26rem;
              text-align: left;
              font-style: normal;
            }
            .des_zs {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.26rem;
              color: #1a1a1a;
              line-height: 0.37rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.3rem;
            }
          }
          .right {
            .zhengshu {
              width: 1.39rem;
              height: 1.89rem;
              margin-top: 0;
            }
          }
        }
        .certificationRow:last-child {
          border-bottom: none;
        }
      }
      .p4_img {
        width: 10.74rem;
        height: 10.74rem;
      }
    }
    .partFive {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 15.19rem;
      background-color: #f0f2f5;
      // background-color: #fff;

      .p5_img {
        width: 10.74rem;
        height: 10.74rem;
        margin-right: 2.61rem;
        // margin-left: -3.7037rem;
      }
      .right {
        .txt {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #141414;
          line-height: 1.11rem;
          
          text-align: right;
          font-style: normal;
        }
        .makeBtn {
          width: 4.67rem;
          height: 1.11rem;
          background: #c25e4d;
          border-radius: 0.74rem;

          display: flex;
          align-items: center;
          justify-content: center;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.3rem;
          color: #ffffff;
          line-height: 0.41rem;
          text-align: left;
          font-style: normal;

          margin-top: 0.78rem;

          .arrR {
            margin-left: 0.19rem;
            width: 0.3rem;
            height: 0.2rem;
          }
        }
        .makeBtn:hover {
          background-color: #d35e4f;
        }
      }
    }
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .qualityContainer_m {
    display: none;
  }
  .qualityContainer_pc {
    position: relative;
    .topPart {
      height: 9.93rem;
      display: flex;
      .left {
        height: 100%;
        width: 40%;
        background: #c25e4d;

        display: flex;
        justify-content: center;
        align-items: center;

        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 0.81rem;
        color: #ffffff;
        line-height: 1.33rem;
        text-align: left;
        font-style: normal;
      }
      .top_right_pic {
        height: 100%;
        width: 60%;
      }
      .top_right_pic_1440 {
        display: none;
      }
    }
    .gridBox {
      width: 25.91rem;
      height: 4.37rem;
      background: linear-gradient(
        141deg,
        #cecece 0%,
        #ffffff 52%,
        #dadada 100%,
        #e6e6e6 100%
      );
      box-shadow: 0rem 0.04rem 0.07rem 0rem rgba(0, 0, 0, 0.08);
      border-radius: 0.15rem;

      position: absolute;
      left: 50%;
      z-index: 1;
      transform: translateX(-50%);
      top: 8.76rem;

      display: flex;
      padding: 1rem 0;

      .item {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px dashed rgba(0, 0, 0, 0.22);
        .icon {
          width: 1.15rem;
          height: 1.15rem;
        }
        .label1 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 0.33rem;
          color: #141414;
          line-height: 0.52rem;
          text-align: right;
          font-style: normal;
          margin-top: 0.39rem;
        }
        .label2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.3rem;
          text-align: right;
          font-style: normal;
          margin-top: 0.19rem;
        }
      }
    }
    .partThree {
      // background-color: #f0f2f5;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 6.17rem;
      padding-bottom: 2.96rem;
      .p3_img {
        width: 11.52rem;
        height: 10.11rem;
        margin-right: 3.39rem;
      }
      .right {
        .mainTitle {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;
          text-align: left;
          font-style: normal;
        }
        .subTitle {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #333333;
          line-height: 0.56rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.15rem;
        }
        .des {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.26rem;
          color: #141414;
          line-height: 0.52rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.46rem;
        }
        .p3_brand_img {
          width: 10.89rem;
          height: 2.63rem;
          margin-top: 1.11rem;
        }
      }
    }
    .partFour {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 16.72rem;
      background: #f6f4f1;
      .left {
        margin-right: 3.17rem;
        .title1 {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #1a1a1a;
          line-height: 0.96rem;
          text-align: left;
          font-style: normal;
        }
        .title2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 0.41rem;
          color: #1a1a1a;
          line-height: 0.56rem;
          text-align: left;
          font-style: normal;
          margin-top: 0.15rem;
        }

        .certificationRow {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 2.52rem;
          border-bottom: 0.01rem solid #1a1a1a;
          width: 10.52rem;
          .left {
            .name {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 0.3rem;
              color: #1a1a1a;
              line-height: 0.26rem;
              text-align: left;
              font-style: normal;
            }
            .des_zs {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 0.26rem;
              color: #1a1a1a;
              line-height: 0.37rem;
              text-align: left;
              font-style: normal;
              margin-top: 0.3rem;
            }
          }
          .right {
            .zhengshu {
              width: 1.39rem;
              height: 1.89rem;
              margin-top: 0;
            }
          }
        }
        .certificationRow:last-child {
          border-bottom: none;
        }
      }
      .p4_img {
        width: 12.26rem;
        height: 12.28rem;
      }
    }
    .partFive {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 15.19rem;
      // background-color: #f0f2f5;
      background-color: #fff;

      .p5_img {
        width: 10.74rem;
        height: 10.74rem;
        margin-right: 2.61rem;
        margin-left: -3.7037rem;
      }
      .right {
        .txt {
          font-family: MADEEvolveSans, MADEEvolveSans;
          font-weight: bold;
          font-size: 0.81rem;
          color: #141414;
          line-height: 1.11rem;
          text-align: right;
          font-style: normal;
        }
        .makeBtn {
          width: 4.67rem;
          height: 1.11rem;
          background: #c25e4d;
          border-radius: 0.74rem;

          display: flex;
          align-items: center;
          justify-content: center;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 0.3rem;
          color: #ffffff;
          line-height: 0.41rem;
          text-align: left;
          font-style: normal;

          margin-top: 0.78rem;

          .arrR {
            margin-left: 0.19rem;
            width: 0.3rem;
            height: 0.2rem;
          }
        }
        .makeBtn:hover {
          background-color: #d35e4f;
        }
      }
    }
  }
}
</style>
  